import React from "react"

import {
  ButtonLink,
  ButtonContainerBlue,
  ButtonContainerWhite,
  ButtonContainerSecondaryBlack,
  ButtonContainerSecondaryWhite,
  ButtonContainerWhiteForm,
  ButtonContainerBlueForm,
  ButtonContainerNav,
  ButtonText,
  ButtonIcon,
} from "./ButtonsElement"

import ArrowWhite from "../../../static/SVGs/arrow-white.svg"
import ArrowBlack from "../../../static/SVGs/arrow-black.svg"

export const ButtonPrimaryBlue = ({ text, link, textMargin }) => {
  return (
    <ButtonLink to={link}>
      <ButtonContainerBlue>
        <ButtonText textMargin={textMargin}>{text}</ButtonText>
        <ButtonIcon>
          <svg
            width="48"
            height="16"
            viewBox="0 0 48 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M46.7517 8.70711C47.1422 8.31658 47.1422 7.68342 46.7517 7.29289L40.3877 0.928933C39.9972 0.538408 39.364 0.538408 38.9735 0.928933C38.583 1.31946 38.583 1.95262 38.9735 2.34315L44.6304 8L38.9735 13.6569C38.583 14.0474 38.583 14.6805 38.9735 15.0711C39.364 15.4616 39.9972 15.4616 40.3877 15.0711L46.7517 8.70711ZM0.213379 9L46.0446 9L46.0446 7L0.213379 7L0.213379 9Z"
              fill="white"
            />
          </svg>
        </ButtonIcon>
      </ButtonContainerBlue>
    </ButtonLink>
  )
}

export const ButtonPrimaryWhite = ({ text, link, textMargin, noArrow }) => {
  return (
    <ButtonLink to={link}>
      <ButtonContainerWhite>
        <ButtonText textMargin={textMargin}>{text}</ButtonText>
        <ButtonIcon noArrow={noArrow}>
          <svg
            width="48"
            height="16"
            viewBox="0 0 48 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M46.7517 8.70711C47.1422 8.31658 47.1422 7.68342 46.7517 7.29289L40.3877 0.928933C39.9972 0.538408 39.364 0.538408 38.9735 0.928933C38.583 1.31946 38.583 1.95262 38.9735 2.34315L44.6304 8L38.9735 13.6569C38.583 14.0474 38.583 14.6805 38.9735 15.0711C39.364 15.4616 39.9972 15.4616 40.3877 15.0711L46.7517 8.70711ZM0.213379 9L46.0446 9L46.0446 7L0.213379 7L0.213379 9Z"
              fill="black"
            />
          </svg>
        </ButtonIcon>
      </ButtonContainerWhite>
    </ButtonLink>
  )
}

export const ButtonSecondaryBlack = ({ text, link, textMargin }) => {
  return (
    <ButtonLink to={link}>
      <ButtonContainerSecondaryBlack>
        <ButtonText textMargin={textMargin}>{text}</ButtonText>
        <ButtonIcon>
          <svg
            width="48"
            height="16"
            viewBox="0 0 48 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M46.7517 8.70711C47.1422 8.31658 47.1422 7.68342 46.7517 7.29289L40.3877 0.928933C39.9972 0.538408 39.364 0.538408 38.9735 0.928933C38.583 1.31946 38.583 1.95262 38.9735 2.34315L44.6304 8L38.9735 13.6569C38.583 14.0474 38.583 14.6805 38.9735 15.0711C39.364 15.4616 39.9972 15.4616 40.3877 15.0711L46.7517 8.70711ZM0.213379 9L46.0446 9L46.0446 7L0.213379 7L0.213379 9Z"
              fill="black"
            />
          </svg>
        </ButtonIcon>
      </ButtonContainerSecondaryBlack>
    </ButtonLink>
  )
}

export const ButtonSecondaryWhite = ({ text, link, textMargin }) => {
  return (
    <ButtonLink to={link}>
      <ButtonContainerSecondaryWhite>
        <ButtonText textMargin={textMargin}>{text}</ButtonText>
        <ButtonIcon>
          <svg
            width="48"
            height="16"
            viewBox="0 0 48 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M46.7517 8.70711C47.1422 8.31658 47.1422 7.68342 46.7517 7.29289L40.3877 0.928933C39.9972 0.538408 39.364 0.538408 38.9735 0.928933C38.583 1.31946 38.583 1.95262 38.9735 2.34315L44.6304 8L38.9735 13.6569C38.583 14.0474 38.583 14.6805 38.9735 15.0711C39.364 15.4616 39.9972 15.4616 40.3877 15.0711L46.7517 8.70711ZM0.213379 9L46.0446 9L46.0446 7L0.213379 7L0.213379 9Z"
              fill="white"
            />
          </svg>
        </ButtonIcon>
      </ButtonContainerSecondaryWhite>
    </ButtonLink>
  )
}

export const ButtonFormWhite = ({ text, textMargin }) => {
  return (
    <ButtonContainerWhiteForm type="submit">
      <ButtonText textMargin={textMargin}>{text}</ButtonText>
      <ButtonIcon>
        <svg
          width="48"
          height="16"
          viewBox="0 0 48 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M46.7517 8.70711C47.1422 8.31658 47.1422 7.68342 46.7517 7.29289L40.3877 0.928933C39.9972 0.538408 39.364 0.538408 38.9735 0.928933C38.583 1.31946 38.583 1.95262 38.9735 2.34315L44.6304 8L38.9735 13.6569C38.583 14.0474 38.583 14.6805 38.9735 15.0711C39.364 15.4616 39.9972 15.4616 40.3877 15.0711L46.7517 8.70711ZM0.213379 9L46.0446 9L46.0446 7L0.213379 7L0.213379 9Z"
            fill="black"
          />
        </svg>
      </ButtonIcon>
    </ButtonContainerWhiteForm>
  )
}

export const ButtonFormBlue = ({ text, textMargin }) => {
  return (
    <ButtonContainerBlueForm type="submit">
      <ButtonText textMargin={textMargin}>{text}</ButtonText>
      <ButtonIcon>
        <svg
          width="48"
          height="16"
          viewBox="0 0 48 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M46.7517 8.70711C47.1422 8.31658 47.1422 7.68342 46.7517 7.29289L40.3877 0.928933C39.9972 0.538408 39.364 0.538408 38.9735 0.928933C38.583 1.31946 38.583 1.95262 38.9735 2.34315L44.6304 8L38.9735 13.6569C38.583 14.0474 38.583 14.6805 38.9735 15.0711C39.364 15.4616 39.9972 15.4616 40.3877 15.0711L46.7517 8.70711ZM0.213379 9L46.0446 9L46.0446 7L0.213379 7L0.213379 9Z"
            fill="white"
          />
        </svg>
      </ButtonIcon>
    </ButtonContainerBlueForm>
  )
}

export const ButtonNav = ({ text, link, textMargin }) => {
  return (
    <ButtonLink to={link}>
      <ButtonContainerNav>
        <ButtonText textMargin={textMargin}>{text}</ButtonText>
        <ButtonIcon>
          <svg
            width="48"
            height="16"
            viewBox="0 0 48 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M46.7517 8.70711C47.1422 8.31658 47.1422 7.68342 46.7517 7.29289L40.3877 0.928933C39.9972 0.538408 39.364 0.538408 38.9735 0.928933C38.583 1.31946 38.583 1.95262 38.9735 2.34315L44.6304 8L38.9735 13.6569C38.583 14.0474 38.583 14.6805 38.9735 15.0711C39.364 15.4616 39.9972 15.4616 40.3877 15.0711L46.7517 8.70711ZM0.213379 9L46.0446 9L46.0446 7L0.213379 7L0.213379 9Z"
              fill="white"
            />
          </svg>
        </ButtonIcon>
      </ButtonContainerNav>
    </ButtonLink>
  )
}
